interface Config {
  ORYX_URL: string;
  PARTNER_URL: string;
  API_URL: string;
  D7_URL: string;
  Z3_URL: string;
  GOOGLE_CLIENT_ID: string;
  PUSHER_APP_KEY: string;
  PUSHER_APP_CLUSTER: string;
  DEPLOYMENT_CHANNEL: string;
  RUM_APP_MONITOR_ID: string;
  RUM_IDENTITY_POOL_ID: string;
  RUM_ENVIRONMENT: 'prod' | 'dev';
}

const dev: Config = {
  ORYX_URL: 'https://oryx-qa.zicasso.com',
  PARTNER_URL: 'https://partners-qa.zicasso.com',
  API_URL: 'https://api-qa.zicasso.com/',
  D7_URL: 'https://d7-qa.zicasso.com/',
  Z3_URL: 'https://www-qa.zicasso.com/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '06182979eb72c66e3ee0',
  PUSHER_APP_CLUSTER: 'us3',
  DEPLOYMENT_CHANNEL: 'z4-deployments-qa',
  RUM_APP_MONITOR_ID: 'be3dda56-b763-4343-9113-39025167fae0',
  RUM_IDENTITY_POOL_ID: 'us-west-2:b0dedd49-5b15-49ee-ac7e-0ec2995a7586',
  RUM_ENVIRONMENT: 'dev',
};

const local: Config = {
  ...dev,
  API_URL: 'http://localhost:8080/',
};

const staging: Config = {
  ORYX_URL: 'https://oryx-staging.zicasso.com',
  PARTNER_URL: 'https://partners-staging.zicasso.com',
  API_URL: 'https://api-staging.zicasso.com/',
  D7_URL: 'https://d7-staging.zicasso.com/',
  Z3_URL: 'https://www-staging.zicasso.com/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '06182979eb72c66e3ee0',
  PUSHER_APP_CLUSTER: 'us3',
  DEPLOYMENT_CHANNEL: 'z4-deployments-staging',
  RUM_APP_MONITOR_ID: 'be3dda56-b763-4343-9113-39025167fae0',
  RUM_IDENTITY_POOL_ID: 'us-west-2:b0dedd49-5b15-49ee-ac7e-0ec2995a7586',
  RUM_ENVIRONMENT: 'dev',
};

const prod: Config = {
  ORYX_URL: 'https://oryx.zicasso.com',
  PARTNER_URL: 'https://partners.zicasso.com',
  API_URL: 'https://api.zicasso.com/',
  D7_URL: 'https://d7.zicasso.com/',
  Z3_URL: 'https://www.zicasso.com/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '88f77513b2a5e074a7e5',
  PUSHER_APP_CLUSTER: 'us3',
  DEPLOYMENT_CHANNEL: 'z4-deployments-prod',
  RUM_APP_MONITOR_ID: 'c77d3b30-1998-4afd-94fe-af173765a8b8',
  RUM_IDENTITY_POOL_ID: 'us-west-2:e4b128d9-b7e0-461f-9919-828e7fe173e2',
  RUM_ENVIRONMENT: 'prod',
};

const qa: Config = {
  ORYX_URL: 'https://oryx-qa.zicasso.com',
  PARTNER_URL: 'https://partners-qa.zicasso.com',
  API_URL: 'https://api-qa.zicasso.com/',
  D7_URL: 'https://d7-qa.zicasso.com/',
  Z3_URL: 'https://www-qa.zicasso.com/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '06182979eb72c66e3ee0',
  PUSHER_APP_CLUSTER: 'us3',
  DEPLOYMENT_CHANNEL: 'z4-deployments-qa',
  RUM_APP_MONITOR_ID: 'be3dda56-b763-4343-9113-39025167fae0',
  RUM_IDENTITY_POOL_ID: 'us-west-2:b0dedd49-5b15-49ee-ac7e-0ec2995a7586',
  RUM_ENVIRONMENT: 'dev',
};

// eslint-disable-next-line import/no-mutable-exports
let config: Config;
if (process.env.REACT_APP_STAGE === 'prod') {
  config = { ...prod };
} else if (process.env.REACT_APP_STAGE === 'staging') {
  config = { ...staging };
} else if (process.env.REACT_APP_STAGE === 'qa') {
  config = { ...qa };
} else if (process.env.REACT_APP_STAGE === 'local') {
  config = { ...local };
} else {
  config = { ...dev };
}

export default config;
